import React, { useState, useEffect } from 'react';
import axios from '../library/axios'
import { getSlug, } from "../config/routes/guards/slug";

const fetchDataArray = async (id) => {
  const options = {
    url: `/chapters/listVariableByIdDocument/${id}`,
    method: 'GET',
    headers: {
      'Access-Control-Allow-Origin': '*',
      Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
    },
  };

  return await axios(options)
    .then((response) => response.data)
    .catch((error) => {
      console.error('Error fetching data array:', error);
      return [];
    });
};


const ArrayCell = ({ row }) => {
  const [dataArray, setDataArray] = useState([]);

  console.log(dataArray[0]?.mapping_document_to_eps)

  useEffect(() => {
    let isMounted = true;
    fetchDataArray(row.idMasterDocument).then((data) => {
      if (isMounted) {
        setDataArray(data);
      }
    });

    return () => {
      isMounted = false;
    };
  }, [row.idMasterDocument]);

  return (
    <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
      {dataArray[0]?.mapping_document_to_eps.map((item, index) => (
        <>
          &nbsp;<span class="badge badge-info" style={{ margin: '3px' }}>&nbsp;{item.variables_accreditation.elements_accreditation.Nomor} {item.variables_accreditation.Abjad}</span>
        </>
      ))}
    </div>
  );
};

export default ArrayCell;